module.exports = __webpack_public_path__ + "static/TACO3-35629194bfa9856f5d152e4fde005269.jpg";